var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OrderSummaryWrapper } from './Wrapper';
import { OrderSummaryHeader } from './Header';
import { OrderSummaryDetailsDropdown, ToggleText } from './Dropdown';
import { OrderSummaryOverview } from './Overview';
import { OrderSummaryDetails } from './Details';
import { OrderSummaryFooter } from '../UI/Footer';
import { Hidden } from '../UI/Hidden';
export var OrderSummary = function (_a) {
    var hideHeader = _a.hideHeader;
    return (_jsxs(OrderSummaryWrapper, { children: [_jsx(OrderSummaryHeader, __assign({ hideHeader: hideHeader }, { children: _jsx(Hidden, __assign({ "$mobileOnly": true }, { children: _jsx(ToggleText, {}) })) })), _jsx(OrderSummaryDetailsDropdown, {}), _jsx(OrderSummaryOverview, {}), _jsx(OrderSummaryDetails, {}), _jsx(OrderSummaryFooter, { "$desktopOnly": true })] }));
};
//# sourceMappingURL=Summary.js.map